export default "__VITE_ASSET__aZt4Mn6L__"